export const UNIT_OF_MEASUREMENT_EXPORT_ID = 'unit-of-measurement';

export const UNIT_OF_MEASUREMENT_TITLE = 'Unidades de Medida';

export const LOCALIZED_PROPERTIES = {
  code: 'Codigo',
  name: 'Nombre',
  statusId: 'Estado',
};
